import {
  getSupplierRetailersAll,
  getSupplierUsers,
  addUser,
  deleteUserInvitation,
  deleteUser,
  putUserRetailers,
} from './api/suppliers';

import { alertError, alertSuccess } from './alert';
import { SUPPLIER_ADMIN_USERS, SUPPLIER_ADMIN_USERS_LOADING } from '../constants/supplierAdminUsersTypes';

const setSupplierAdminUsers = (data) => ({ type: SUPPLIER_ADMIN_USERS, payload: data });
const setSupplierAdminUsersLoading = (value) => ({ type: SUPPLIER_ADMIN_USERS_LOADING, payload: value });

export const getSupplierAdminUsers =
  (showLoading = true) =>
  async (dispatch, getState) => {
    const { supplierId } = getState().role;

    if (showLoading) {
      dispatch(setSupplierAdminUsersLoading(true));
    }

    try {
      const usersResponse = await getSupplierUsers(supplierId);
      const retailersResponse = await getSupplierRetailersAll(supplierId);

      dispatch(
        setSupplierAdminUsers({
          users: usersResponse.data,
          retailers: retailersResponse.data,
        }),
      );
    } catch (error) {
      dispatch(alertError(error));
      dispatch(setSupplierAdminUsersLoading(false));
    }
  };

export const updateSupplierUserRetailers = (userEmail, data) => async (dispatch, getState) => {
  const { supplierId } = getState().role;

  try {
    const response = await putUserRetailers(supplierId, {
      ...data,
      email: userEmail,
    });

    if (response.data && response.status === 201) {
      dispatch(alertSuccess("User's permissions updated"));
    } else {
      dispatch(alertError('Error'));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const deleteSupplierUser = (id) => async (dispatch, getState) => {
  const { supplierId } = getState().role;

  try {
    const response = await deleteUser(supplierId, id);

    if (response.data.success) {
      dispatch(alertSuccess('Success'));
      dispatch(getSupplierAdminUsers(false));
    } else {
      dispatch(alertError('Error'));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const deleteSupplierUserInvitation = (email) => async (dispatch, getState) => {
  const { supplierId, supplier } = getState().role;

  try {
    const response = await deleteUserInvitation(supplierId, email);

    if (response.data.success) {
      dispatch(alertSuccess(`User with email ${email} was successfully uninvited to ${supplier.name}.`));
      dispatch(getSupplierAdminUsers(false));
    } else {
      dispatch(alertError('Error'));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const addSupplierUser = (data) => async (dispatch, getState) => {
  const { supplierId, supplier } = getState().role;

  try {
    const response = await addUser(supplierId, data);
    if (response.data && response.status === 201) {
      dispatch(getSupplierAdminUsers(false));
      dispatch(alertSuccess(`User with email ${data.email} was successfully invited to ${supplier.name}.`));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};
